import { render } from "./webPushMessages.html?vue&type=template&id=77864293&ts=true&external"
import script from "./webPushMessages.ts?vue&type=script&lang=ts&external"
export * from "./webPushMessages.ts?vue&type=script&lang=ts&external"

import "./webPushMessages.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__